module.exports = __webpack_public_path__ + "img/MoblieBack.39b497a1.svg";